import { IconButton } from '@vimeo/bokeh';
import { Menu } from '@vimeo/bokeh-icons';
import { useViewer } from '@vimeo/viewer';

import { trackNavigationActionEvent } from '../../tracking';

export const SideNavToggle = ({
  isSideNavActive,
  setIsSideNavActive,
}: {
  isSideNavActive: boolean;
  setIsSideNavActive: VoidFunction;
}) => {
  const viewer = useViewer();
  return (
    <IconButton
      aria-label="open-sidenav"
      icon={<Menu />}
      variant="tertiary"
      display={isSideNavActive ? 'none' : 'flex'}
      onClick={() => {
        setIsSideNavActive();
        trackNavigationActionEvent({ copy: 'hamburger_menu', element: 'button', viewer });
      }}
      size={{ base: 'xs', sm: 'sm', md: 'md' }}
      data-testid="open-sidenav"
    />
  );
};
